import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { PayrollValueObjectsConceptUnitTypeEnum } from 'generated/resources/datatable.graphql'
import { CompensationValidationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { formatValue } from 'modules/compensations/pages/CompensationsPayrollRun/CompensationsFormFields/formatUtils'
import { usePayrollConceptCompensationUnits } from 'modules/payroll_bundle/hooks/usePayrollConceptCompensationUnits'

import { CompensationsAggregatesAlertPopover } from './CompensationsAggregatesAlertPopover'

type CompensationsFormAggregatesProps = {
  unitType: PayrollValueObjectsConceptUnitTypeEnum
  validation?: CompensationValidationFragment
  inputAmount?: number
  resultAmount?: number
  isLoading: boolean
}

function CompensationsFormAggregates({
  unitType,
  validation,
  inputAmount,
  resultAmount,
  isLoading,
}: CompensationsFormAggregatesProps) {
  const {
    access: { locale },
  } = useCurrentSession()

  const unitSymbol = usePayrollConceptCompensationUnits(unitType)
  const textCompensations =
    inputAmount !== undefined ? formatValue(inputAmount, unitType, unitSymbol, locale) : '-'
  const textResult =
    resultAmount !== undefined
      ? formatValue(resultAmount, unitType, unitSymbol, locale) || '-'
      : validation
      ? i18n.t('compensations.CompensationsFormFields.missing')
      : '-'
  const color = validation ? 'tangerine1000' : 'grey800'

  if (inputAmount === undefined && resultAmount === undefined) return <></>

  return (
    <Box flexDirection="row" justifyContent="flexStart" gap="s8" alignItems="center">
      <Text size="200" color="grey700">
        {i18n.t('compensations.CompensationsFormFields.input')}
      </Text>
      {!isLoading && (
        <Text size="200" color="grey800">
          {textCompensations}
        </Text>
      )}
      <Divider component="div" vertical />
      <Text size="200" color="grey700">
        {i18n.t('compensations.CompensationsFormFields.results')}
      </Text>
      {!isLoading && (
        <Text size="200" color={color}>
          {textResult}
        </Text>
      )}
      {(isLoading || validation) && (
        <CompensationsAggregatesAlertPopover
          validation={validation}
          inputAmount={inputAmount || 0}
          resultAmount={resultAmount}
          isLoading={isLoading}
        />
      )}
    </Box>
  )
}

export { CompensationsFormAggregates }
